import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAllowNumber]'
})
export class AllowNumberDirective {
  inputElement: HTMLElement;
  numperArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "."]
  constructor(private el: ElementRef) {
    this.inputElement = this.el.nativeElement
  }


  @Input() appAllowNumber: boolean;
  @Input() appSpecialCharacter: boolean = false;
  @Input() maxNumber: number = -1;
  @HostListener('keypress', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    try {
      if (this.appAllowNumber) {
        
        const pattern = /[0-9.,]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
          console.log("e.keyCode_02", event.keyCode, this.appAllowNumber)
          // invalid character, prevent input
          event.preventDefault();
        }
        if (this.maxNumber != -1) {
          console.log("e.keyCode_03", event.keyCode, this.appAllowNumber)
          if (this.maxNumber - 1 < String(this.el.nativeElement.value).length) {
            e.preventDefault();
          }
        }

      } else {
        if (this.maxNumber != -1) {
          if (this.maxNumber - 1 < String(this.el.nativeElement.value).length) {
            e.preventDefault();
          }
        }
      }
    } catch (eve) {
      console.log("eve",eve)
    }
  }

}
